import { render, staticRenderFns } from "./parts4.vue?vue&type=template&id=2c4efff3&scoped=true&"
import script from "./parts4.vue?vue&type=script&lang=ts&"
export * from "./parts4.vue?vue&type=script&lang=ts&"
import style0 from "./parts4.vue?vue&type=style&index=0&id=2c4efff3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4efff3",
  null
  
)

export default component.exports